module.exports = __webpack_public_path__ + "img/hidden01.e18381d4.jpg";